export const SALE_INVOICE_STATUS = [
  { id: "draft", name: "Draft" },
  { id: "awaiting_approval", name: "Awaiting Approval" },
  { id: "sent", name: "Approved" },
  { id: "overdue", name: "Overdue" },
  { id: "paid", name: "Paid" },
  { id: "void", name: "Void" },
  { id: "written_off", name: "Written Off" },
];

/**
 * Default sale-invoice list columns, including Fulfillment.
 *
 * @const
 * @type {!Array<string>}
 */
export const SALE_INVOICE_DEFAULT_COLUMNS = [
  "INVOICE NO",
  "CUSTOMER",
  "CREATE DATE",
  "DUE DATE",
  "REFERENCE NO",
  "SUB TOTAL",
  "TAX",
  "TOTAL",
  "CURRENCY",
  "FULFILLMENT",
  "STATUS",
];

/**
 * List headers that filter by fulfillment issue_types.
 *
 * Older saved views may still be named Issues or Fulfillment Status.
 *
 * @const
 * @type {!Array<string>}
 */
export const SALE_INVOICE_FULFILLMENT_FILTER_HEADERS = [
  "issues",
  "fulfillment",
  "fulfillment status",
];

export const SALE_INVOICE_FULFILLMENT_HEADERS =
  SALE_INVOICE_FULFILLMENT_FILTER_HEADERS;

/**
 * Fulfillment filter options for list and detail tables.
 *
 * @const
 * @type {!Array<{id: string, name: string}>}
 */
export const SALE_INVOICE_FULFILLMENT_FILTER_OPTIONS = [
  { id: "error", name: "Error" },
  { id: "warning", name: "Warning" },
  { id: "processed", name: "Processed" },
];
